<div class="loader-full">
    <div 
        class="loader-container d-flex align-items-center justify-content-center"
        [style]="{
            'padding-block': padding
        }"
    >
        <div class="loader"></div>
        <p class="loader-text mb-0" *ngIf="message">{{ message }}</p>
    </div>
</div>